import { createAnalysisPage } from '@/features/analysisPage/components/AnalysisPageFactory';

export const AnalysisVendorsPage = createAnalysisPage({
  type: 'vendor',
  baseRoute: '/analysis/vendors',
});
